// Mock data for Elite Plugin Hub

export const categories = [
  { id: 'all', name: 'All Plugins', icon: 'Grid' },
  { id: 'economy', name: 'Economy', icon: 'DollarSign' },
  { id: 'protection', name: 'Protection', icon: 'Shield' },
  { id: 'minigames', name: 'Minigames', icon: 'Gamepad2' },
  { id: 'admin', name: 'Admin Tools', icon: 'Settings' },
  { id: 'gameplay', name: 'Gameplay', icon: 'Zap' },
];

export const plugins = [
  {
    id: 1,
    name: 'EliteVault Pro',
    tagline: 'Advanced economy & chest protection',
    description: 'Full-featured economy system with virtual chest storage, player shops, and auction house. Includes anti-grief protection and advanced permissions.',
    category: 'economy',
    price: 15.99,
    rating: 4.9,
    reviews: 342,
    badge: 'Premium',
    compatibility: ['Paper 1.20+', 'Spigot 1.19+', 'Geyser'],
    version: '3.4.2',
    fileSize: '2.8 MB',
    downloads: 15420,
    lastUpdated: '2025-03-15',
    features: [
      'Multi-currency support',
      'Virtual chest storage (unlimited)',
      'Player shops with GUI',
      'Global auction house',
      'Advanced permission system',
      'MySQL & SQLite support',
      'Auto-updates enabled',
      '30-day priority support'
    ],
    changelog: '3.4.2: Fixed dupe glitch, added new shop templates\n3.4.1: Performance improvements\n3.4.0: Added auction house feature',
    demoServer: 'demo.eliteplugins.net:25565',
    supportChannel: 'Discord: #elitevault-support',
  },
  {
    id: 2,
    name: 'PvP Arena Master',
    tagline: 'Ultimate PvP arena & tournament system',
    description: 'Create and manage unlimited PvP arenas with ELO ranking, tournaments, spectator mode, and custom kits. Perfect for competitive servers.',
    category: 'minigames',
    price: 0,
    rating: 4.7,
    reviews: 521,
    badge: 'Free',
    compatibility: ['Paper 1.20+', 'Spigot 1.18+'],
    version: '2.1.5',
    fileSize: '1.4 MB',
    downloads: 28350,
    lastUpdated: '2025-03-10',
    downloadLink: 'https://drive.google.com/file/d/your-pvp-arena-file/view?usp=sharing',
    features: [
      'Unlimited arena creation',
      'ELO ranking system',
      'Tournament brackets',
      'Custom kit builder',
      'Spectator mode',
      'Replay system',
      'Leaderboards',
      'Community support'
    ],
    changelog: '2.1.5: Fixed kit loading bug\n2.1.4: Added replay feature\n2.1.0: Tournament system released',
    demoServer: 'pvp.eliteplugins.net:25565',
    supportChannel: 'Discord: #arena-support',
  },
  {
    id: 3,
    name: 'WorldGuard Elite',
    tagline: 'Next-gen region protection & management',
    description: 'Advanced region protection with custom flags, dynamic borders, and AI-powered grief detection. Seamless WorldEdit integration.',
    category: 'protection',
    price: 24.99,
    rating: 5.0,
    reviews: 189,
    badge: 'New',
    compatibility: ['Paper 1.20+', 'Spigot 1.20+', 'Geyser'],
    version: '1.2.0',
    fileSize: '3.2 MB',
    downloads: 5840,
    lastUpdated: '2025-03-20',
    features: [
      'AI-powered grief detection',
      'Dynamic region borders',
      'Custom flag system',
      'WorldEdit integration',
      'Cross-server region sync',
      'Advanced permissions',
      'Real-time notifications',
      'Premium support'
    ],
    changelog: '1.2.0: Initial release with AI detection',
    demoServer: 'protection.eliteplugins.net:25565',
    supportChannel: 'Discord: #worldguard-elite',
  },
  {
    id: 4,
    name: 'Admin Command Suite',
    tagline: 'Complete server management toolkit',
    description: 'All-in-one admin toolkit with custom commands, moderation tools, server analytics, and automated backups.',
    category: 'admin',
    price: 0,
    rating: 4.8,
    reviews: 892,
    badge: 'Free',
    compatibility: ['Paper 1.19+', 'Spigot 1.19+', 'Geyser'],
    version: '4.7.3',
    fileSize: '2.1 MB',
    downloads: 42150,
    lastUpdated: '2025-03-18',
    downloadLink: 'https://drive.google.com/file/d/your-admin-suite-file/view?usp=sharing',
    features: [
      '200+ admin commands',
      'Moderation toolkit',
      'Server analytics dashboard',
      'Automated backups',
      'Player tracking',
      'Custom command builder',
      'Multi-language support',
      'Community support'
    ],
    changelog: '4.7.3: Added analytics dashboard\n4.7.2: Fixed backup system\n4.7.0: Major update',
    demoServer: 'admin.eliteplugins.net:25565',
    supportChannel: 'Discord: #admin-tools',
  },
  {
    id: 5,
    name: 'Custom Enchants Pro',
    tagline: 'Unlimited custom enchantments',
    description: 'Create unlimited custom enchantments with particle effects, sounds, and special abilities. Fully configurable with GUI editor.',
    category: 'gameplay',
    price: 19.99,
    rating: 4.6,
    reviews: 278,
    badge: 'Premium',
    compatibility: ['Paper 1.20+', 'Spigot 1.19+'],
    version: '2.8.1',
    fileSize: '2.5 MB',
    downloads: 11200,
    lastUpdated: '2025-03-12',
    features: [
      'Unlimited custom enchants',
      'Particle effect library',
      'GUI enchant editor',
      'Special ability system',
      'Enchant books trading',
      'Level scaling',
      'MySQL support',
      '30-day support'
    ],
    changelog: '2.8.1: Added new particle effects\n2.8.0: GUI editor released\n2.7.5: Bug fixes',
    demoServer: 'enchants.eliteplugins.net:25565',
    supportChannel: 'Discord: #enchants-pro',
  },
  {
    id: 6,
    name: 'SkyBlock Plus',
    tagline: 'Modern skyblock experience',
    description: 'Complete skyblock plugin with island leveling, custom challenges, coop mode, and marketplace.',
    category: 'gameplay',
    price: 29.99,
    rating: 4.9,
    reviews: 445,
    badge: 'Premium',
    compatibility: ['Paper 1.20+', 'Geyser'],
    version: '5.2.0',
    fileSize: '4.1 MB',
    downloads: 18750,
    lastUpdated: '2025-03-22',
    features: [
      'Island leveling system',
      'Custom challenge builder',
      'Coop mode (8 players)',
      'Island marketplace',
      'Biome upgrades',
      'Minion system',
      'Cross-server support',
      'Premium support'
    ],
    changelog: '5.2.0: Added marketplace feature\n5.1.8: Performance boost\n5.1.5: New challenges',
    demoServer: 'skyblock.eliteplugins.net:25565',
    supportChannel: 'Discord: #skyblock-plus',
  },
];

export const featuredPlugins = plugins.filter(p => p.badge === 'Premium' || p.badge === 'New').slice(0, 3);

export const testimonials = [
  {
    id: 1,
    name: 'MinecraftPro_YT',
    role: 'Server Owner - SkyPvP Network',
    content: 'EliteVault Pro transformed our economy system. The support team is incredibly responsive!',
    rating: 5,
    avatar: 'MP',
  },
  {
    id: 2,
    name: 'BuilderKing',
    role: 'Admin - Creative Realms',
    content: 'Best plugin marketplace. High quality, regular updates, and amazing custom work.',
    rating: 5,
    avatar: 'BK',
  },
  {
    id: 3,
    name: 'RedstoneWizard',
    role: 'Developer - Tech Server',
    content: 'The custom plugin they built for us was perfect. Delivered on time and works flawlessly.',
    rating: 5,
    avatar: 'RW',
  },
];

export const stats = [
  { value: '50K+', label: 'Active Downloads' },
  { value: '1,500+', label: 'Happy Customers' },
  { value: '200+', label: 'Custom Builds' },
  { value: '24/7', label: 'Discord Support' },
];